import React from "react";
import { StyledLoadingdiv, StyledProgressdiv } from "./ProgressBar.style";

export default function ProgressBarCM(props) {
  return (
    <StyledLoadingdiv>
      <label htmlFor="file"> در حال بارگذاری </label>
      <br />
      <StyledProgressdiv id="file" value={props.value} max="100" />
    </StyledLoadingdiv>
  );
}
